/**
 * Utility per gestire contenuto HTML
 */

/**
 * Estrae il testo puro da una stringa HTML
 */
export const stripHtml = (html: string): string => {
  if (!html) return '';
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

